import type { DataViewDesignTokens, DataViewTokenSections } from '@openng/optimus-ui-themes/types/dataview';

export const header: DataViewTokenSections.Header = {
	borderWidth: '1',
};

export const footer: DataViewTokenSections.Footer = {
	borderWidth: '1',
};

export const paginatorTop: DataViewTokenSections.PaginatorTop = {
	borderWidth: '1',
};

export const paginatorBottom: DataViewTokenSections.PaginatorBottom = {
	borderWidth: '1',
};

export default {
	header,
	footer,
	paginatorTop,
	paginatorBottom,
} satisfies DataViewDesignTokens;
